import { Injectable } from '@angular/core';

import { Session } from '../../models/Sessions/Session';
import { BusService } from '../bus.service';
import { EventsService } from '../events.service';
import { RequestService } from '../request.service';

// Meta tracking service. Tracks internal and Google Analytics

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  api = {
    root: '/tracking',
  };

  constructor(
    private client: RequestService,
    private bus: BusService,
    private events: EventsService,
  ) {
    this.subscribe();
  }

  public emitGa(
    eventCategory: string,
    eventAction: string,

    eventLabel: string = null,

    eventValue: number = null,
  ) {
    // this.gaService.emitEvent(eventCategory, eventAction, eventLabel, eventValue);
  }

  private track(
    session: Session,
    category: string,
    action: string,
    label: string = null,
    value: number = null,
    userId: any = null,
    meta?: any,
  ) {
    this.emitGa(category, action, label, value);
    this.post(session, category, action, label, value, userId, meta);
  }

  private post(
    session: Session,
    category: string,
    action: string,
    label: string = null,
    value: number = null,
    userId: any = null,
    meta?: any,
  ) {
    this.client.post<any, any>({
      uri: this.api.root,
      body: {
        session_id: session._id,
        user_id:
          userId || (session && session.me ? session.me.user_id : undefined),
        category,
        action,
        label,
        value,
        meta,
      },
      handlers: {
        success: response =>
          this.bus.publish(
            this.events.received.action.tracking.track.success,
            response,
          ),
        error: error =>
          this.bus.publish(
            this.events.received.action.tracking.track.failure,
            error.error,
          ),
      },
    });
  }

  private subscribe() {
    this.bus.subscribe(
      this.events.requested.action.tracking.track,
      this.track.bind(this),
    );
  }
}
